import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'dc-no-permissions',
  templateUrl: './no-permissions.component.html',
  styleUrls: ['./no-permissions.component.scss'],
  imports: [MatIcon],
})
export class NoPermissionsComponent {
  image = 'img/assets/dimc/onboarding/undraw_security_o890.svg';
}
